import { createStore } from 'vuex'

export default createStore({
  state: {
    CBMA_API_URL: "https://api.v1.yeram.net/cbms/api/v1"
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
